import{nothing as D}from"../lit-html.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const to=t=>t??D;export{to as ifDefined};
//# sourceMappingURL=if-defined.js.map
